import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import heroStrategic from "../../static/media/Home/hero_strategic.webp";

const MotionBox = motion(Box);
const MotionTypography = motion(Typography);

export default function HeroStrategic() {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        minHeight: { xs: "68vh", md: "90vh" },
        display: "flex",
        alignItems: "center",
        overflow: "hidden",
        bgcolor: "#050505",
      }}
    >
      <MotionBox
        component="img"
        src={heroStrategic}
        alt="Alianzas NovaXFit"
        initial={{ scale: 1.06, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.2 }}
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectPosition: { xs: "center", md: "center" },
        }}
      />

      <MotionBox
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1 }}
        sx={{
          position: "absolute",
          inset: 0,
          background: {
            xs: "linear-gradient(180deg, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.56) 38%, rgba(0,0,0,0.88) 100%)",
            md: "linear-gradient(90deg, rgba(0,0,0,0.88) 0%, rgba(0,0,0,0.72) 32%, rgba(0,0,0,0.38) 62%, rgba(0,0,0,0.52) 100%)",
          },
        }}
      />

      <MotionBox
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 1.1 }}
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at top right, rgba(229,9,20,0.18) 0%, rgba(229,9,20,0.08) 20%, rgba(0,0,0,0) 48%)",
        }}
      />

      <Container
        maxWidth="xl"
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        <MotionBox
          initial={{ opacity: 0, y: 36 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          sx={{
            width: { xs: "100%", md: "58%", lg: "54%" },
            maxWidth: 980,
            py: { xs: 9, md: 12 },
          }}
        >
          <MotionTypography
            component="h1"
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.1 }}
            sx={{
              fontSize: {
                xs: "clamp(40px, 7vw, 58px)",
                md: "clamp(72px, 4vw, 110px)",
              },
              lineHeight: { xs: 0.94, md: 0.88 },
              letterSpacing: { xs: -2, md: -3.8 },
              fontWeight: 700,
              textTransform: "uppercase",
              color: "#ffffff",
              maxWidth: "100%",
            }}
          >
            Alianzas que elevan la experiencia
            <Box
              component={motion.span}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.25 }}
              sx={{
                display: "block",
                mt: { xs: 0.4, md: 0.5 },
                background:
                  "linear-gradient(180deg, #ff3d3d 0%, #e50914 42%, #b90610 74%, #ff6464 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                fontWeight: 700,
              }}
            >
              con NovaXFit
            </Box>
          </MotionTypography>

          <MotionTypography
            initial={{ opacity: 0, y: 26 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.2 }}
            sx={{
              mt: { xs: 2.4, md: 3 },
              fontSize: { xs: 16, md: 20 },
              lineHeight: { xs: 1.7, md: 1.8 },
              color: "rgba(255,255,255,0.82)",
              fontWeight: 500,
              maxWidth: { xs: "100%", md: 760 },
            }}
          >
            En NovaXFit trabajamos junto a marcas y profesionales aliados para brindar 
            beneficios exclusivos a nuestros miembros activos. Conoce los descuentos y promociones 
            disponibles presentando tu membresía vigente.
          </MotionTypography>
        </MotionBox>
      </Container>
    </Box>
  );
}